import { NotificacaoDto } from '@/api.types';

const TITULO_PADRAO = 'Notificação';

export function notificacaoTituloExibicao(titulo?: NotificacaoDto['titulo']): string {
  const valor = titulo?.trim();
  return valor || TITULO_PADRAO;
}

export function notificacaoDetalhesExibicao(
  detalhes?: NotificacaoDto['detalhes'],
): string | null {
  const valor = detalhes?.trim();
  return valor || null;
}
